'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = require('./internal/_filter');

var _filter3 = _interopRequireDefault(_filter2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _match = require('./match');

var _match2 = _interopRequireDefault(_match);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function where(pattern, subject) {
  return (0, _filter3.default)((0, _match2.default)(pattern), subject);
}

/**
 * Takes items in `subject` that match `pattern`.
 *
 * @example
 * const users = Map({
 *   123: {id: '123', name: 'Jack'},
 *   456: {id: '456', name: 'Jill'},
 * });
 *
 * where({name: 'Jack'}, users);
 * // returns Map { 123: {id: '123', name: 'Jack'} }
 *
 * @param  {Function} pattern
 * @param  {Iterable} subject
 * @return {Iterable}
 */
exports.default = (0, _curry2.default)(where);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/where.js
// module id = 396
// module chunks = 0 1